export default "__VITE_ASSET__C4mjoE5___"